module.exports = __webpack_public_path__ + "img/walletcard_chip.0cedfbf4.png";